export default {
  audits: [],
  stats: null,
  pagination: {
    currentPage: 1,
    totalPage: 0,
    pageTotal: 0,
    totalItem: 0,
    limit: 25,
    offset: 0,
  },
}
